<template>
    <div class="container">
        <div class="box">
            <h2 class="title is-2">Job Description</h2>
            <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                <tbody>
                    <tr>
                        <td>Organization</td>
                        <td class="has-text-centered">{{ job.organization }}</td>
                    </tr>
                    <tr>
                        <td>Location</td>
                        <td class="has-text-centered">{{ job.location }}</td>
                    </tr>
                    <tr>
                        <td>Posting Date</td>
                        <td class="has-text-centered">{{ job.post_date }}</td>
                    </tr>
                    <tr v-if="job.salary_display">
                        <td>Compensation</td>
                        <td class="has-text-centered">
                            {{ job.salary_display }}
                            <span
                                  v-if="job.salary_is_from_description"
                                  class="is-size-7 has-text-grey">({{ job.salary_source_label }})</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="box">
            <h4 class="title is-4">Job Title: {{ job.jobtitle }}</h4>
            <div
                 class="container content"
                 v-html="sanitizedJobDesc"></div>
        </div>
        <div class="box">
            <p
               v-if="job.auth"
               class="buttons">
                <a
                   :href="job.url"
                   class="button is-info">Visit Page URL</a>
                <button
                        v-if="job.matched === false"
                        :key=job.matched
                        class="button is-primary"
                        @click="$emit('select_job_to_match', job)">
                    Interested? Add To List
                </button>
                <span
                      v-if="job.matched"
                      :key=job.matched
                      class="button is-info is-inverted">Already Added to List!</span>
            </p>
            <p
               v-else
               class="buttons">
                <a
                   :href="job.url"
                   class="button is-info">Visit Page URL</a>
            </p>
            <p
               v-if="jobMatchID"
               class="buttons">
                <button
                        class="button"
                        :class="isRelevant === true ? 'is-primary' : isRelevant === false ? 'is-danger' : 'is-light is-info'"
                        @click="$emit('select_job_to_match', job, jobMatchID, isRelevant)">{{ buttonText }}
                </button>
            </p>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from "vue"
import DOMPurify from "dompurify"
import { formatJobDesc } from "../../utils"

const props = defineProps<{
  job: any
  jobMatchID?: string
  isRelevant?: boolean | null
}>()

defineEmits<{
  select_job_to_match: [job: any, jobMatchID?: string, isRelevant?: boolean | null]
}>()

// Prefer the server-enriched, pre-sanitized jobdesc_html when present;
// still pass it through DOMPurify as client-side defense-in-depth. Fall
// back to formatting the plain-text jobdesc when no HTML is available.
const sanitizedJobDesc = computed(() =>
  DOMPurify.sanitize(
    props.job?.jobdesc_html || formatJobDesc(props.job?.jobdesc ?? ""),
  )
)

const buttonText = computed(() =>
  props.isRelevant === true ? "Interested!" :
  props.isRelevant === false ? "Not Interested" :
  "Interested?"
)
</script>
